import { useMemo } from 'react';
import { useSmartLinkContext } from '@atlaskit/link-provider';
export const useSmartLinkRenderers = () => {
  const context = useSmartLinkContext();
  let renderers = context === null || context === void 0 ? void 0 : context.renderers;
  renderers = useMemo(() => renderers, [renderers]);
  return renderers;
};